module.exports = __webpack_public_path__ + "media/images/flags/4x3/prk-9fd3021e3f7d74dc7a574388cd9581c9.svg";